import { all, takeEvery, takeLatest, put, call, select } from "redux-saga/effects";
import { toast } from 'react-hot-toast';
import organizationStripeBillingAddEditSlice,  { createOrganizationStripeCustomer, loadOrganizationStripeBilling } from "./slice";
import { IConfiguration } from "../../../shared/types";
import { SimplyTestApi } from "../../../api/simplytest";
import { selectConfig } from "../../../shared/redux/slice";
import { selectIdToken, unauthorized } from "../../../auth/redux/slice";
import { AxiosResponse } from "axios";
import { OrganizationStripeBilling } from "../../../api/types";
import { generatePath } from "react-router-dom";
import { ROUTES } from "../../../shared/constants";
import Swal from 'sweetalert2';

export abstract class OrganizationStripeBillingAddEditSagas {
    public static* run() {
        try {
            yield all([
                takeLatest(loadOrganizationStripeBilling, OrganizationStripeBillingAddEditSagas.loadOrganizationStripeBilling),
                takeLatest(createOrganizationStripeCustomer, OrganizationStripeBillingAddEditSagas.createOrganizationStripeCustomer),
            ]);
        }
        catch(e: any){
            toast.error('Unable to register OrganizationBillingAddEdit module.');
            console.log(`[OrganizationBillingAddEditSagas:run] the following exception has occurred`, e);
        }
    }

    public static* loadOrganizationStripeBilling(action: ReturnType<typeof loadOrganizationStripeBilling>){
        const { payload: { orgId }} = action;
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);
            
            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const loadOrgResponse: AxiosResponse<OrganizationStripeBilling> = yield call(
                {
                    context: client,
                    fn: client.getOrganizationStripeBilling,
                },
                orgId,
            );

            if(loadOrgResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;     
            }
            
            if(loadOrgResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(organizationStripeBillingAddEditSlice.actions.setOrganizationStripeBilling(loadOrgResponse.data));
        }
        catch(e: any){
            toast.error('Unable to load organization Stripe billing data.');
            console.log(`[OrganizationBillingAddEditSagas:loadOrganizationStripeBilling] the following exception has occurred`, e);
        }
    }

    public static* createOrganizationStripeCustomer(action: ReturnType<typeof createOrganizationStripeCustomer>){
        const { payload: { orgId, name, postalcode }} = action;
        try {
            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const createCustomerResponse: AxiosResponse<string> = yield call(
                {
                    context: client,
                    fn: client.createOrganizationStripeCustomer,
                },
                orgId,
                name,
                postalcode,
            );

            if(createCustomerResponse.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(createCustomerResponse.status !== 200)
                throw new Error("Error communicating with Api");

            yield put(loadOrganizationStripeBilling({ orgId }));
        }
        catch(e: any){
            toast.error('Unable to set up Stripe billing for this organization.');
            console.log(`[OrganizationBillingAddEditSagas:createOrganizationStripeCustomer] the following exception has occurred`, e);
        }
    }


}
